exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".five-stars:hover {\n  cursor: pointer;\n  color: black; }\n", ""]);

// exports
